import React, { useEffect } from "react";
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import './SomosVolteon.css';
import {getOrderProducts} from '../services/getOrders'
import { migrateDraftToNewOrder } from "../services/posOrders";

const stats = [
    { value: "2021", label: "Año de fundación" },
    { value: "2", label: "Puntos de venta en el TEC" },
    { value: "100%", label: "Enfoque didáctico" },
];

const sections = [
    {
        title: "Nuestra historia",
        text: `Fundada en noviembre de 2021, Volteon Electronics nació como una empresa de venta de
        componentes electrónicos dirigida especialmente a las necesidades de estudiantes y personas
        nuevas en el mundo de la electrónica. Conscientes de las pocas opciones disponibles en el
        mercado y habiendo experimentado de primera mano la dificultad existente para adquirir
        componentes electrónicos, especialmente para los principiantes, Volteon se creó con el ideal
        de mejorar la accesibilidad de las personas a este tipo de productos. Esto con el fin de
        desarrollar una nueva cultura alrededor de la electrónica y crear una experiencia de
        adquisición de componentes única a nivel nacional.`,
    },
    {
        title: "Un enfoque didáctico",
        text: `Volteon se caracteriza por su enfoque didáctico, proporcionando siempre material instructivo
        para que el cliente pueda aprender más acerca del artículo adquirido. Esto mediante el
        desarrollo de manuales, tarjetas informativas y guías de usuario propias de Volteon. Con este
        contenido se consigue una mayor inmersión del cliente en la experiencia Volteon, adquiriendo
        acceso incluso a material digital fácilmente accesible para cualquier persona.`,
    },
    {
        title: "Diseño que enamora",
        text: `Volteon le da una gran importancia a la parte visual de sus productos, pues entiende que los
        compradores merecen una presentación atractiva en los componentes electrónicos que adquieren.
        Parte de la experiencia que busca brindar Volteon es que sus clientes adquieran artículos
        visualmente agradables y llamativos.`,
    },
    {
        title: "Alianzas que construyen comunidad",
        text: `Desde su fundación, Volteon ha creado alianzas estratégicas con instituciones educativas de
        gran renombre a nivel nacional, lo que ha beneficiado a los estudiantes de las mismas en el
        desarrollo de sus proyectos académicos. Actualmente Volteon cuenta con dos puntos de venta
        dentro del Tecnológico de Costa Rica sede de Cartago, en las oficinas de las Asociaciones de
        Estudiantes de las carreras de Ingeniería Electrónica e Ingeniería en Computadores.`,
    },
    {
        title: "Siempre hacia adelante",
        text: `Con el objetivo de mantenerse innovando, Volteon constantemente actualiza su inventario para
        ofrecer cada vez una mayor variedad de componentes, al igual que desarrolla nuevos productos
        para satisfacer las necesidades del cliente en un mundo en permanente crecimiento tecnológico.
        Como parte de las futuras mejoras, Volteon busca expandir sus alianzas comerciales a otras
        instituciones del país, además de encontrarse desarrollando una manera de ofrecer nuevos
        servicios más allá de la venta de componentes electrónicos.`,
    },
];

const SomosVolteon = () => {
    //NO BORRAR, ES UN ESPACIO PARA REALIZAR PRUEBAS EN FUNCIONES

      /*useEffect(() => {
        // Función para cargar los productos
        const loadProducts = async () => {
          const p = await migrateDraftToNewOrder(663, 206, 4, 106);
          console.log(p);
        };
        loadProducts();
      }, []);*/
    return (
        <div>
            <Header />

            <div className="volteon-hero">
                <div className="volteon-hero-text">
                    <span className="volteon-eyebrow" aria-hidden="true" />
                    <h1>Somos Volteon</h1>
                    <p className="volteon-tagline">
                        Conectamos a estudiantes y makers costarricenses con el mundo de la
                        electrónica, con componentes accesibles y material didáctico propio.
                    </p>
                </div>
                <img src="/images/leon.png" alt="León" className="volteon-hero-image" />
            </div>

            <div className="volteon-stats">
                {stats.map((stat) => (
                    <div className="volteon-stat-card" key={stat.label}>
                        <span className="volteon-stat-value">{stat.value}</span>
                        <span className="volteon-stat-label">{stat.label}</span>
                    </div>
                ))}
            </div>

            <div className="volteon-sections">
                {sections.map((section) => (
                    <section className="volteon-section" key={section.title}>
                        <h2>{section.title}</h2>
                        <p>{section.text}</p>
                    </section>
                ))}
            </div>

            <div className="volteon-cta">
                <p>
                    Desde Volteon deseamos que el cliente siempre esté satisfecho con sus
                    adquisiciones. Te invitamos a compartirnos tus comentarios y sugerencias, que
                    para nosotros son fundamentales para mejorar cada día y contribuir a que la
                    cultura alrededor del mundo de la electrónica siga en desarrollo.
                </p>
            </div>

            <Footer />
        </div>
    );
};

export default SomosVolteon;
